"use client";

import Link from "next/link";
import Image from "next/image";
import { FiLock } from "react-icons/fi";
import Input from "@/app/components/ui/forms/Input";
import Button from "@/app/components/ui/buttons/Button";
import Checkbox from "@/app/components/ui/forms/Checkbox";
import { useLoginForm } from "../hooks/useLoginForm";

export default function LoginForm() {
  const { form, loading, onSubmit } = useLoginForm();
  const { register, formState: { errors } } = form;

  return (
    <div className="w-full max-w-md rounded-md bg-white p-8">
      <div className="mb-10 text-center">
        <Image src="/images/logo.png" alt="Logo" width={150} height={50} loading="eager" className="mx-auto mb-8" />
        <h2 className="mb-2 text-3xl font-bold text-gray-900">Hoş Geldiniz</h2>
        <p className="text-gray-600">Hesabınıza giriş yaparak devam edin</p>
      </div>

      <form onSubmit={onSubmit} className="space-y-6">
        <div className="space-y-4">
          <Input
            label="E-posta Adresi"
            name="email"
            type="email"
            register={register}
            placeholder="ornek@email.com"
            error={errors.email}
          />
          <Input
            label="Şifre"
            name="password"
            type="password"
            placeholder="••••••••"
            register={register}
            error={errors.password}
          />
        </div>

        <div className="flex items-center justify-between">
          <Checkbox label="Beni hatırla" name="remember_me" register={register} />
          <Link
            href="/forgot-password"
            className="text-sm font-medium text-xBlue transition-colors duration-200 hover:text-xBlue/80"
          >
            Şifremi unuttum
          </Link>
        </div>

        <Button type="submit" fullWidth className="py-3 text-base font-medium" disabled={loading}>
          <span className="flex items-center justify-center gap-2">
            <FiLock className="h-4 w-4" />
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </span>
        </Button>
      </form>
    </div>
  );
}